import React, { useState } from "react";
import { BrowserRouter as Router, withRouter } from "react-router-dom";
import "bootstrap";
import Accordion from "react-bootstrap/Accordion";
import dateFormat, { masks } from "dateformat";
import { leaseDateFormat } from "../../utils/utils";
class PropertyTax extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pTaxDetails: this.props.pTaxDetails,
      pTaxPayable: this.props.pTaxPayable,
    };
  }

  render() {
    return (
      <div className="tabHolder mb-4">
        <div className="row tabForm">
          <Accordion defaultActiveKey="0">
            {this.state.pTaxPayable == "yes" ? (
              this.state.pTaxDetails.map(function (pTax, index) {
                if (pTax.pTaxLogicValue == 1) {
                  return (
                    <div className="container-fluid p-0">
                      <div className="row prospectAccordion">
                        <div className="col-lg-12 p-0">
                          <Accordion.Item eventKey={index}>
                            <Accordion.Header>
                              {`Period `}
                              {` `}
                              {pTax.period}
                              {` `}
                              {`-`}
                              {` `}
                              {pTax.pTaxLogicText}
                              {` - `}
                              {`( Period Term - ${
                                pTax.periodTermYY == ""
                                  ? "0"
                                  : pTax.periodTermYY
                              }Y -${
                                pTax.periodTermMM == ""
                                  ? "0"
                                  : pTax.periodTermMM
                              }M -${
                                pTax.periodTermDD == ""
                                  ? "0"
                                  : pTax.periodTermDD
                              }D )`}
                              {` - `}
                              {`From ${leaseDateFormat(pTax.fromDate)}`}
                              {` `}
                              {`To ${leaseDateFormat(pTax.toDate)}`}
                            </Accordion.Header>
                            <Accordion.Body>
                              <div className="container-fluid">
                                <div className="row">
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Period{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {pTax.period}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Period Term{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {pTax.periodTermYY == ""
                                            ? "0"
                                            : pTax.periodTermYY}
                                          {"-"}
                                          {pTax.periodTermMM == ""
                                            ? "0"
                                            : pTax.periodTermMM}
                                          {"-"}
                                          {pTax.periodTermDD == ""
                                            ? "0"
                                            : pTax.periodTermDD}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Property and Municipal Tax Logic{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {pTax.pTaxLogicText}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="row">
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          From <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {leaseDateFormat(pTax.fromDate)}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          To <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {leaseDateFormat(pTax.toDate)}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  {pTax.pTaxLogicText !=
                                    "Property Tax Basis Actual" && (
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            PTax UOM{" "}
                                            <span className="astrik">*</span>
                                          </label>
                                          <label className="col-sm-7 col-form-label">
                                            {pTax.pTaxUom}
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                  {pTax.pTaxLogicText !=
                                    "Property Tax Basis Actual" && (
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            On Area{" "}
                                            <span className="astrik">*</span>
                                          </label>
                                          <label className="col-sm-7 col-form-label">
                                            {pTax.onArea}
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                  {pTax.pTaxLogicText !=
                                    "Property Tax Basis Actual" && (
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            PTax Rate{" "}
                                            <span className="astrik">*</span>
                                          </label>
                                          <label className="col-sm-7 col-form-label">
                                            {pTax.pTaxRate}
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          PTax Rate Term{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {pTax.pTaxRateTerm}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          PTax Frequency{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {pTax.pTaxFrequency}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          PTax Due Date{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {pTax.pTaxDueDate}
                                          {`-`}
                                          {pTax.pTaxDueType}
                                          {`-`}
                                          {pTax.pTaxDueFrequency}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                {pTax.pTaxLogicText !=
                                  "Property Tax Basis Actual" && (
                                  <div className="row">
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            PTax Capped{" "}
                                            <span className="astrik">*</span>
                                          </label>
                                          <label className="col-sm-7 col-form-label">
                                            {pTax.ptaxCapped}
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                    {pTax.ptaxCapped == "yes" && (
                                      <div className="pTaxCapped row">
                                        <div className="col-lg-6">
                                          <div className="inputContainer col-lg-12 col-md-12">
                                            <div className="row mb-3">
                                              <label className="col-sm-4 col-form-label">
                                                PTax Capped UOM{" "}
                                                <span className="astrik">
                                                  *
                                                </span>
                                              </label>
                                              <label className="col-sm-7 col-form-label">
                                                {pTax.pTaxCappedUom}
                                              </label>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="col-lg-6">
                                          <div className="inputContainer col-lg-12 col-md-12">
                                            <div className="row mb-3">
                                              <label className="col-sm-4 col-form-label">
                                                PTax Capped on Area{" "}
                                                <span className="astrik">
                                                  *
                                                </span>
                                              </label>
                                              <label className="col-sm-7 col-form-label">
                                                {pTax.pTaxCappedOnArea}
                                              </label>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="col-lg-6">
                                          <div className="inputContainer col-lg-12 col-md-12">
                                            <div className="row mb-3">
                                              <label className="col-sm-4 col-form-label">
                                                PTax Capped Rate{" "}
                                                <span className="astrik">
                                                  *
                                                </span>
                                              </label>
                                              <label className="col-sm-7 col-form-label">
                                                {pTax.ptaxCappedRate}
                                              </label>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="col-lg-6">
                                          <div className="inputContainer col-lg-12 col-md-12">
                                            <div className="row mb-3">
                                              <label className="col-sm-4 col-form-label">
                                                PTax Capped Rate Term{" "}
                                                <span className="astrik">
                                                  *
                                                </span>
                                              </label>
                                              <label className="col-sm-7 col-form-label">
                                                {pTax.ptaxCappedRateTerm}
                                              </label>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                )}
                                {pTax.rates !== undefined &&
                                  pTax.rates.map(function (name, index) {
                                    return (
                                      <div className="row rateRow">
                                        <div className="col-lg-6">
                                          <div className="inputContainer col-lg-12 col-md-12">
                                            <div className="row mb-3">
                                              <label className="col-sm-5 col-form-label">
                                                From{" "}
                                                <span className="astrik">
                                                  *
                                                </span>
                                              </label>
                                              <label className="col-sm-7 col-form-label">
                                                {leaseDateFormat(name.from)}
                                              </label>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="col-lg-6">
                                          <div className="inputContainer col-lg-12 col-md-12">
                                            <div className="row mb-3">
                                              <label className="col-sm-5 col-form-label">
                                                To{" "}
                                                <span className="astrik">
                                                  *
                                                </span>
                                              </label>
                                              <label className="col-sm-7 col-form-label">
                                                {leaseDateFormat(name.to)}
                                              </label>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="col-lg-6">
                                          <div className="inputContainer col-lg-12 col-md-12">
                                            <div className="row mb-3">
                                              <label className="col-sm-5 col-form-label">
                                                PTax UOM{" "}
                                                <span className="astrik">
                                                  *
                                                </span>
                                              </label>
                                              <label className="col-sm-7 col-form-label">
                                                {name.pTaxUom}
                                              </label>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="col-lg-6">
                                          <div className="inputContainer col-lg-12 col-md-12">
                                            <div className="row mb-3">
                                              <label className="col-sm-5 col-form-label">
                                                On Area{" "}
                                                <span className="astrik">
                                                  *
                                                </span>
                                              </label>
                                              <label className="col-sm-7 col-form-label">
                                                {name.onArea}
                                              </label>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="col-lg-6">
                                          <div className="inputContainer col-lg-12 col-md-12">
                                            <div className="row mb-3">
                                              <label className="col-sm-5 col-form-label">
                                                Rate{" "}
                                                <span className="astrik">
                                                  *
                                                </span>
                                              </label>
                                              <label className="col-sm-7 col-form-label">
                                                {name.rate}
                                              </label>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    );
                                  }, this)}
                              </div>
                            </Accordion.Body>
                          </Accordion.Item>
                        </div>
                      </div>
                    </div>
                  );
                } else if (pTax.pTaxLogicValue == 2) {
                  return (
                    <div className="container-fluid p-0">
                      <div className="row prospectAccordion">
                        <div className="col-lg-12 p-0">
                          <Accordion.Item eventKey={index}>
                            <Accordion.Header>
                              {`Period `}
                              {` `}
                              {pTax.period}
                              {` `}
                              {`-`}
                              {` `}
                              {pTax.pTaxLogicText}
                              {` - `}
                              {`( Period Term - ${
                                pTax.periodTermYY == ""
                                  ? "0"
                                  : pTax.periodTermYY
                              }Y -${
                                pTax.periodTermMM == ""
                                  ? "0"
                                  : pTax.periodTermMM
                              }M -${
                                pTax.periodTermDD == ""
                                  ? "0"
                                  : pTax.periodTermDD
                              }D )`}
                              {` - `}
                              {`From ${leaseDateFormat(pTax.fromDate)}`}
                              {` `}
                              {`To ${leaseDateFormat(pTax.toDate)}`}
                            </Accordion.Header>
                            <Accordion.Body>
                              <div className="container-fluid">
                                <div className="row">
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Period{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {pTax.period}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Period Term{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {pTax.periodTermYY == ""
                                            ? "0"
                                            : pTax.periodTermYY}
                                          {"-"}
                                          {pTax.periodTermMM == ""
                                            ? "0"
                                            : pTax.periodTermMM}
                                          {"-"}
                                          {pTax.periodTermDD == ""
                                            ? "0"
                                            : pTax.periodTermDD}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Property and Municipal Tax Logic{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {pTax.pTaxLogicText}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="row">
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          From <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {leaseDateFormat(pTax.fromDate)}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          To <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {leaseDateFormat(pTax.toDate)}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          PTax Revenue Share (%){" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {pTax.revenueShare}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          PTax Rate Term{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {pTax.pTaxRateTerm}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          PTax Frequency{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {pTax.pTaxFrequency}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          PTax Due Date{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {pTax.pTaxDueDate}
                                          {`-`}
                                          {pTax.pTaxDueType}
                                          {`-`}
                                          {pTax.pTaxDueFrequency}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="row">
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          PTax Capped{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {pTax.ptaxCapped}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  {pTax.ptaxCapped == "yes" && (
                                    <div className="pTaxCapped row">
                                      <div className="col-lg-6">
                                        <div className="inputContainer col-lg-12 col-md-12">
                                          <div className="row mb-3">
                                            <label className="col-sm-4 col-form-label">
                                              PTax Capped UOM{" "}
                                              <span className="astrik">*</span>
                                            </label>
                                            <label className="col-sm-7 col-form-label">
                                              {pTax.pTaxCappedUom}
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-lg-6">
                                        <div className="inputContainer col-lg-12 col-md-12">
                                          <div className="row mb-3">
                                            <label className="col-sm-4 col-form-label">
                                              PTax Capped on Area{" "}
                                              <span className="astrik">*</span>
                                            </label>
                                            <label className="col-sm-7 col-form-label">
                                              {pTax.pTaxCappedOnArea}
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-lg-6">
                                        <div className="inputContainer col-lg-12 col-md-12">
                                          <div className="row mb-3">
                                            <label className="col-sm-4 col-form-label">
                                              PTax Capped Rate{" "}
                                              <span className="astrik">*</span>
                                            </label>
                                            <label className="col-sm-7 col-form-label">
                                              {pTax.ptaxCappedRate}
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-lg-6">
                                        <div className="inputContainer col-lg-12 col-md-12">
                                          <div className="row mb-3">
                                            <label className="col-sm-4 col-form-label">
                                              PTax Capped Rate Term{" "}
                                              <span className="astrik">*</span>
                                            </label>
                                            <label className="col-sm-7 col-form-label">
                                              {pTax.ptaxCappedRateTerm}
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </Accordion.Body>
                          </Accordion.Item>
                        </div>
                      </div>
                    </div>
                  );
                } else if (pTax.pTaxLogicValue == 3) {
                  return (
                    <div className="container-fluid p-0">
                      <div className="row prospectAccordion">
                        <div className="col-lg-12 p-0">
                          <Accordion.Item eventKey={index}>
                            <Accordion.Header>
                              {`Period `}
                              {` `}
                              {pTax.period}
                              {` `}
                              {`-`}
                              {` `}
                              {pTax.pTaxLogicText}
                              {` - `}
                              {`( Period Term - ${
                                pTax.periodTermYY == ""
                                  ? "0"
                                  : pTax.periodTermYY
                              }Y -${
                                pTax.periodTermMM == ""
                                  ? "0"
                                  : pTax.periodTermMM
                              }M -${
                                pTax.periodTermDD == ""
                                  ? "0"
                                  : pTax.periodTermDD
                              }D )`}
                              {` - `}
                              {`From ${leaseDateFormat(pTax.fromDate)}`}
                              {` `}
                              {`To ${leaseDateFormat(pTax.toDate)}`}
                            </Accordion.Header>
                            <Accordion.Body>
                              <div className="container-fluid">
                                <div className="row">
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Period{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {pTax.period}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Period Term{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {pTax.periodTermYY == ""
                                            ? "0"
                                            : pTax.periodTermYY}
                                          {"-"}
                                          {pTax.periodTermMM == ""
                                            ? "0"
                                            : pTax.periodTermMM}
                                          {"-"}
                                          {pTax.periodTermDD == ""
                                            ? "0"
                                            : pTax.periodTermDD}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Property and Municipal Tax Logic{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {pTax.pTaxLogicText}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="row">
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          From <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {leaseDateFormat(pTax.fromDate)}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          To <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {leaseDateFormat(pTax.toDate)}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-12">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-2 col-form-label">
                                          Revenue Share (%)
                                        </label>
                                        <div className="col-sm-10 slabWidthDesktop">
                                          <div
                                            className="tableContainer"
                                            style={{ padding: "15px" }}
                                          >
                                            <table className="table tableSimple tableSimpleWithNoFlex">
                                              <thead>
                                                <tr>
                                                  <th scope="col">SLAB</th>
                                                  <th scope="col">FROM</th>
                                                  <th scope="col">To</th>
                                                  <th scope="col">
                                                    Revenue Share (%)
                                                  </th>
                                                </tr>
                                              </thead>
                                              <tbody>
                                                {pTax.slabs.length > 0 &&
                                                  pTax.slabs.map(
                                                    (name, index) => (
                                                      <tr key={index}>
                                                        <td>{index + 1}</td>
                                                        <td>{name.from}</td>
                                                        <td>{name.to}</td>
                                                        <td>{name.percent}</td>
                                                      </tr>
                                                    )
                                                  )}
                                              </tbody>
                                            </table>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          PTax Rate Term{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {pTax.pTaxRateTerm}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          PTax Frequency{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {pTax.pTaxFrequency}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          PTax Due Date{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {pTax.pTaxDueDate}
                                          {`-`}
                                          {pTax.pTaxDueType}
                                          {`-`}
                                          {pTax.pTaxDueFrequency}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="row">
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          PTax Capped{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {pTax.ptaxCapped}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  {pTax.ptaxCapped == "yes" && (
                                    <div className="pTaxCapped row">
                                      <div className="col-lg-6">
                                        <div className="inputContainer col-lg-12 col-md-12">
                                          <div className="row mb-3">
                                            <label className="col-sm-4 col-form-label">
                                              PTax Capped UOM{" "}
                                              <span className="astrik">*</span>
                                            </label>
                                            <label className="col-sm-7 col-form-label">
                                              {pTax.pTaxCappedUom}
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-lg-6">
                                        <div className="inputContainer col-lg-12 col-md-12">
                                          <div className="row mb-3">
                                            <label className="col-sm-4 col-form-label">
                                              PTax Capped on Area{" "}
                                              <span className="astrik">*</span>
                                            </label>
                                            <label className="col-sm-7 col-form-label">
                                              {pTax.pTaxCappedOnArea}
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-lg-6">
                                        <div className="inputContainer col-lg-12 col-md-12">
                                          <div className="row mb-3">
                                            <label className="col-sm-4 col-form-label">
                                              PTax Capped Rate{" "}
                                              <span className="astrik">*</span>
                                            </label>
                                            <label className="col-sm-7 col-form-label">
                                              {pTax.ptaxCappedRate}
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-lg-6">
                                        <div className="inputContainer col-lg-12 col-md-12">
                                          <div className="row mb-3">
                                            <label className="col-sm-4 col-form-label">
                                              PTax Capped Rate Term{" "}
                                              <span className="astrik">*</span>
                                            </label>
                                            <label className="col-sm-7 col-form-label">
                                              {pTax.ptaxCappedRateTerm}
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </Accordion.Body>
                          </Accordion.Item>
                        </div>
                      </div>
                    </div>
                  );
                } else if (pTax.pTaxLogicValue == 4) {
                  return (
                    <div className="container-fluid p-0">
                      <div className="row prospectAccordion">
                        <div className="col-lg-12 p-0">
                          <Accordion.Item eventKey={index}>
                            <Accordion.Header>
                              {`Period `}
                              {` `}
                              {pTax.period}
                              {` `}
                              {`-`}
                              {` `}
                              {pTax.pTaxLogicText}
                              {` - `}
                              {`( Period Term - ${
                                pTax.periodTermYY == ""
                                  ? "0"
                                  : pTax.periodTermYY
                              }Y -${
                                pTax.periodTermMM == ""
                                  ? "0"
                                  : pTax.periodTermMM
                              }M -${
                                pTax.periodTermDD == ""
                                  ? "0"
                                  : pTax.periodTermDD
                              }D )`}
                              {` - `}
                              {`From ${leaseDateFormat(pTax.fromDate)}`}
                              {` `}
                              {`To ${leaseDateFormat(pTax.toDate)}`}
                            </Accordion.Header>
                            <Accordion.Body>
                              <div className="container-fluid">
                                <div className="row">
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Period{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {pTax.period}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Period Term{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {pTax.periodTermYY == ""
                                            ? "0"
                                            : pTax.periodTermYY}
                                          {"-"}
                                          {pTax.periodTermMM == ""
                                            ? "0"
                                            : pTax.periodTermMM}
                                          {"-"}
                                          {pTax.periodTermDD == ""
                                            ? "0"
                                            : pTax.periodTermDD}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Property and Municipal Tax Logic{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {pTax.pTaxLogicText}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="row">
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          From <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {leaseDateFormat(pTax.fromDate)}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          To <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {leaseDateFormat(pTax.toDate)}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          PTax UOM{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {pTax.pTaxRentUom}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          On Area{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {pTax.onArea}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          PTax Rate{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {pTax.pTaxRentRate}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Percentage of Rent{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {pTax.percentageofRent}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          PTax Rate Term{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {pTax.pTaxRateTerm}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          PTax Frequency{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {pTax.pTaxFrequency}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          PTax Due Date{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {pTax.pTaxDueDate}
                                          {`-`}
                                          {pTax.pTaxDueType}
                                          {`-`}
                                          {pTax.pTaxDueFrequency}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="row">
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          PTax Capped{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {pTax.ptaxCapped}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  {pTax.ptaxCapped == "yes" && (
                                    <div className="pTaxCapped row">
                                      <div className="col-lg-6">
                                        <div className="inputContainer col-lg-12 col-md-12">
                                          <div className="row mb-3">
                                            <label className="col-sm-4 col-form-label">
                                              PTax Capped UOM{" "}
                                              <span className="astrik">*</span>
                                            </label>
                                            <label className="col-sm-7 col-form-label">
                                              {pTax.pTaxCappedUom}
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-lg-6">
                                        <div className="inputContainer col-lg-12 col-md-12">
                                          <div className="row mb-3">
                                            <label className="col-sm-4 col-form-label">
                                              PTax Capped on Area{" "}
                                              <span className="astrik">*</span>
                                            </label>
                                            <label className="col-sm-7 col-form-label">
                                              {pTax.pTaxCappedOnArea}
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-lg-6">
                                        <div className="inputContainer col-lg-12 col-md-12">
                                          <div className="row mb-3">
                                            <label className="col-sm-4 col-form-label">
                                              PTax Capped Rate{" "}
                                              <span className="astrik">*</span>
                                            </label>
                                            <label className="col-sm-7 col-form-label">
                                              {pTax.ptaxCappedRate}
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-lg-6">
                                        <div className="inputContainer col-lg-12 col-md-12">
                                          <div className="row mb-3">
                                            <label className="col-sm-4 col-form-label">
                                              PTax Capped Rate Term{" "}
                                              <span className="astrik">*</span>
                                            </label>
                                            <label className="col-sm-7 col-form-label">
                                              {pTax.ptaxCappedRateTerm}
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </Accordion.Body>
                          </Accordion.Item>
                        </div>
                      </div>
                    </div>
                  );
                } else if (pTax.pTaxLogicValue == 5) {
                  return (
                    <div className="container-fluid p-0">
                      <div className="row prospectAccordion">
                        <div className="col-lg-12 p-0">
                          <Accordion.Item eventKey={index}>
                            <Accordion.Header>
                              {`Period `}
                              {` `}
                              {pTax.period}
                              {` `}
                              {`-`}
                              {` `}
                              {pTax.pTaxLogicText}
                              {` - `}
                              {`( Period Term - ${
                                pTax.periodTermYY == ""
                                  ? "0"
                                  : pTax.periodTermYY
                              }Y -${
                                pTax.periodTermMM == ""
                                  ? "0"
                                  : pTax.periodTermMM
                              }M -${
                                pTax.periodTermDD == ""
                                  ? "0"
                                  : pTax.periodTermDD
                              }D )`}
                              {` - `}
                              {`From ${leaseDateFormat(pTax.fromDate)}`}
                              {` `}
                              {`To ${leaseDateFormat(pTax.toDate)}`}
                            </Accordion.Header>
                            <Accordion.Body>
                              <div className="container-fluid">
                                <div className="row">
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Period{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {pTax.period}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Period Term{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {pTax.periodTermYY == ""
                                            ? "0"
                                            : pTax.periodTermYY}
                                          {"-"}
                                          {pTax.periodTermMM == ""
                                            ? "0"
                                            : pTax.periodTermMM}
                                          {"-"}
                                          {pTax.periodTermDD == ""
                                            ? "0"
                                            : pTax.periodTermDD}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Property and Municipal Tax Logic{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {pTax.pTaxLogicText}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="row">
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          From <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {leaseDateFormat(pTax.fromDate)}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          To <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {leaseDateFormat(pTax.toDate)}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          PTax Rate Term{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {pTax.pTaxRateTerm}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Type of Vouchers{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {pTax.voucherType}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Amount of Vouchers{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {pTax.voucherAmount}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          PTax Frequency{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {pTax.pTaxFrequency}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          PTax Due Date{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {pTax.pTaxDueDate}
                                          {`-`}
                                          {pTax.pTaxDueType}
                                          {`-`}
                                          {pTax.pTaxDueFrequency}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="row">
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          PTax Capped{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {pTax.ptaxCapped}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  {pTax.ptaxCapped == "yes" && (
                                    <div className="pTaxCapped row">
                                      <div className="col-lg-6">
                                        <div className="inputContainer col-lg-12 col-md-12">
                                          <div className="row mb-3">
                                            <label className="col-sm-4 col-form-label">
                                              PTax Capped Rate{" "}
                                              <span className="astrik">*</span>
                                            </label>
                                            <label className="col-sm-7 col-form-label">
                                              {pTax.ptaxCappedRate}
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-lg-6">
                                        <div className="inputContainer col-lg-12 col-md-12">
                                          <div className="row mb-3">
                                            <label className="col-sm-4 col-form-label">
                                              PTax Capped Rate Term{" "}
                                              <span className="astrik">*</span>
                                            </label>
                                            <label className="col-sm-7 col-form-label">
                                              {pTax.ptaxCappedRateTerm}
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </Accordion.Body>
                          </Accordion.Item>
                        </div>
                      </div>
                    </div>
                  );
                }
              }, this)
            ) : (
              <div className="container">
                <div className="row">
                  <div className="col-lg-12">
                    <h6 className="text-center" style={{ padding: "15px" }}>
                      Property Tax Not Applicable
                    </h6>
                  </div>
                </div>
              </div>
            )}
          </Accordion>
          {this.state.pTaxPayable == "yes" && (
            <div className="container-fluid">
              <div className="row">
                <div className="col-lg-6">
                  <div className="inputContainer col-lg-12 col-md-12">
                    <div className="row mb-3">
                      <label className="col-sm-4 col-form-label">
                        Notes
                        <span className="astrik">*</span>
                      </label>
                      <label className="col-sm-7 col-form-label">
                        {this.props.pTaxNotes}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}
export default withRouter(PropertyTax);
